import { QRCodeSVG } from 'qrcode.react'

interface TicketCardProps {
  ticket: {
    id?: string
    isPrimaryGuest: boolean
    firstName: string | null
    lastName: string | null
    displayName: string | null
    contactPhone: string | null
    email: string | '' | null
    status: 'pending' | 'claimed'
    claimedAt: string | null
  }
}

export function TicketCard({ ticket }: TicketCardProps) {
  const name =
    ticket.displayName ||
    (ticket.firstName && ticket.lastName
      ? `${ticket.firstName} ${ticket.lastName}`
      : 'Guest')

  return (
    <div className="w-full overflow-hidden rounded-3xl border border-stone-200 bg-white shadow-md">
      {/* Ticket Header */}
      <div className="bg-stone-800 p-6 text-center text-white">
        <p className="mb-1 text-xs tracking-widest text-stone-300 uppercase">
          บัตรเชิญงานแต่งงาน
        </p>
        <h2 className="font-serif text-2xl">บัตรเข้างาน</h2>
      </div>

      <div className="flex flex-col items-center p-8">
        {/* QR Code */}
        <div className="flex items-center justify-center rounded-2xl border border-stone-100 bg-white p-4 shadow-sm">
          <QRCodeSVG
            value={ticket.id!}
            size={200}
            bgColor={'#ffffff'}
            fgColor={'#292524'}
            level={'Q'}
          />
        </div>

        <div className="mt-8 space-y-1 text-center">
          <h3 className="text-xl font-semibold text-stone-800">{name}</h3>
          <p className="text-sm text-stone-500">
            โปรดเตรียมตั๋วนี้เพื่อแสดงที่จุดลงทะเบียน
          </p>
        </div>
      </div>

      {/* Ticket Footer (Cut out styling) */}
      <div className="relative mb-6 flex h-6 items-center">
        <div className="absolute top-0 -left-3 size-6 rounded-full border-r border-stone-200 bg-stone-50"></div>
        <div className="mx-4 flex-1 border-t-2 border-dashed border-stone-200"></div>
        <div className="absolute top-0 -right-3 size-6 rounded-full border-l border-stone-200 bg-stone-50"></div>
      </div>

      <div className="px-6 pt-2 pb-6 text-center">
        <div className="font-mono text-xs text-stone-400 uppercase">
          รหัสตั๋ว: {ticket.id!.slice(0, 10)}
        </div>
      </div>
    </div>
  )
}
